import { render, staticRenderFns } from "./sortable-list.vue?vue&type=template&id=ef947156&"
import script from "./sortable-list.vue?vue&type=script&lang=js&"
export * from "./sortable-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports